// extracted by mini-css-extract-plugin
export default {"restaurant-point":"RestaurantPoint_restaurant-point__21BCS"};